export enum ContractBillingType {
  BATCH = 'BATCH',
  INDIVIDUAL = 'INDIVIDUAL',
}
